import React, { useContext,useState, useEffect } from 'react'
import '../styling/Chats.css'

const Chatnav = (props) => {

  const {user,imagesrc}=props
  return (
    <div className='chatnav'>
        <div id="usernav">
            <img src={imagesrc} alt="" id='navimg'/>
            <span> {user.name} </span>
        </div>
    </div>
  )
}

export default Chatnav